webpackJsonp([114276838955818,60335399758886],{

/***/ 383:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(552);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(383);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Social = __webpack_require__(536);
	
	var _Social2 = _interopRequireDefault(_Social);
	
	var _FooterNewModule = __webpack_require__(440);
	
	var _FooterNewModule2 = _interopRequireDefault(_FooterNewModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterNew = function FooterNew() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'footer-new ' + _FooterNewModule2.default.Footer, id: 'site-footer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'footer-wrap' },
	      _react2.default.createElement(
	        'div',
	        { className: 'footer-top' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { className: 'footer-logo', src: '/images/redesign/global-citizen-year-new-logo.svg', alt: ' Global Citizen Year logo' })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'menu-head' },
	            'Fellowship'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/fellowship/' },
	            'Overview'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/experience/fellowship-experience/' },
	            'Experience'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/destinations-overview/' },
	            'Destinations'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/fellow-stories/' },
	            'Fellowship Stories'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/fellowship-faq/' },
	            'FAQ'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'menu-head' },
	            'Academy'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/academy/' },
	            'Overview'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/experience/academy-experience/' },
	            'Experience'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/academy/speakers/' },
	            'Meet the Speakers'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/academy-stories/' },
	            'Academy Stories'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/academy-faq/' },
	            'FAQ'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'menu-head' },
	            'Admissions'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/admissions/' },
	            'Admissions & Tuition'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/financial-aid-tuition/' },
	            'Scholarships'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/what-about-college/' },
	            'What About College'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/gap-year-resources/' },
	            'Gap Year Resources'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'menu-head' },
	            'About Us'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/donate/' },
	            'Donate'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/about-us' },
	            'Our Story'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/our-impact/' },
	            'Our Impact'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/our-team/' },
	            'Our Team'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/press/' },
	            'News & Press'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('div', { className: 'menu-head hide-mobile' }),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/for-educators/' },
	            'For Educators'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/parents/' },
	            'For Parents'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/partners-and-supporters/' },
	            'Partners & Supporters'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/careers/' },
	            'Careers'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'footer-bottom' },
	        _react2.default.createElement(
	          'div',
	          { className: _FooterNewModule2.default.Footer__Left },
	          _react2.default.createElement(
	            'p',
	            null,
	            '1625 Clay Street, Suite 400, Oakland, CA 94612 ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:info@globalcitizenyear.org' },
	              'info@globalcitizenyear.org'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:4159639293' },
	              '415-963-9293'
	            ),
	            _react2.default.createElement('br', null),
	            'Press Inquiries: Please contact Molly Weissman',
	            _react2.default.createElement('br', null),
	            'at ',
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:9174391442' },
	              '917-439-1442'
	            ),
	            ' or ',
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:molly@globalcitizenyear.org' },
	              'molly@globalcitizenyear.org'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Social2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'footer-sublinks ' + _FooterNewModule2.default.Footer__Nav },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.zazzle.com/store/globalcitizenyear', target: '_blank' },
	                'Store'
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/privacy-policy/' },
	                'Privacy Policy'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\xA9 2020 - Global Citizen Year'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = FooterNew;
	module.exports = exports['default'];

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Footer":"src-components-Footer----FooterNew-module---Footer---3reaD","Footer__Wrapper":"src-components-Footer----FooterNew-module---Footer__Wrapper---1DQYG","Footer__Left":"src-components-Footer----FooterNew-module---Footer__Left---3StK9","Footer__Right":"src-components-Footer----FooterNew-module---Footer__Right---1E8iE","Footer__Nav":"src-components-Footer----FooterNew-module---Footer__Nav---q78bb","Footer__Social":"src-components-Footer----FooterNew-module---Footer__Social---30mL-","Footer__Terms":"src-components-Footer----FooterNew-module---Footer__Terms---Nkp6r","HoverItem__Instagram":"src-components-Footer----FooterNew-module---HoverItem__Instagram---33Emp","HoverItem__Youtube":"src-components-Footer----FooterNew-module---HoverItem__Youtube---2WNXh","HoverItem__Snapchat":"src-components-Footer----FooterNew-module---HoverItem__Snapchat---VSmy-","HoverItem__Linkedin":"src-components-Footer----FooterNew-module---HoverItem__Linkedin---30T7V"};

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FooterNewModule = __webpack_require__(440);
	
	var _FooterNewModule2 = _interopRequireDefault(_FooterNewModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Social = function Social() {
	    return _react2.default.createElement(
	        'div',
	        { className: _FooterNewModule2.default.Footer__Social },
	        _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/globalcitizenyr', target: '_blank' },
	            _react2.default.createElement(
	                'svg',
	                { width: '24px', height: '24px', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                _react2.default.createElement(
	                    'g',
	                    { id: '-footer', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', transform: 'translate(-1255.000000, -192.000000)' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'footer', fill: '#000000' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'twitter', transform: 'translate(1255.000000, 192.000000)' },
	                            _react2.default.createElement('path', { d: 'M17.2617,9.3848 C17.2677,9.4978 17.2697,9.6108 17.2697,9.7248 C17.2697,13.2028 14.6217,17.2148 9.7807,17.2148 C8.2947,17.2148 6.9107,16.7778 5.7457,16.0308 C7.1197,16.1918 8.5177,15.8238 9.6427,14.9418 C8.4907,14.9198 7.5197,14.1588 7.1847,13.1128 C7.5807,13.1878 7.9877,13.1738 8.3727,13.0678 C7.1687,12.8268 6.2617,11.7628 6.2617,10.4888 L6.2617,10.4538 C6.6167,10.6508 7.0237,10.7688 7.4537,10.7828 C6.7477,10.3108 6.2827,9.5058 6.2827,8.5928 C6.2827,8.1108 6.4127,7.6588 6.6397,7.2688 C7.9377,8.8618 9.8767,9.9108 12.0647,10.0188 C12.0197,9.8268 11.9957,9.6248 11.9957,9.4198 C11.9957,7.9658 13.1747,6.7868 14.6287,6.7868 C15.3857,6.7868 16.0697,7.1068 16.5497,7.6188 C17.1497,7.4998 18.4997,7.3538 18.4997,7.3538 C18.1477,7.8818 17.7767,9.0128 17.2617,9.3848 M11.9997,-0.0002 C5.3827,-0.0002 -0.0003,5.3828 -0.0003,11.9998 C-0.0003,18.6168 5.3827,23.9998 11.9997,23.9998 C18.6167,23.9998 23.9997,18.6168 23.9997,11.9998 C23.9997,5.3828 18.6167,-0.0002 11.9997,-0.0002', id: 'Fill-400' })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'a',
	            { href: 'https://www.facebook.com/globalcitizenyear', target: '_blank' },
	            _react2.default.createElement(
	                'svg',
	                { width: '24px', height: '24px', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                _react2.default.createElement(
	                    'g',
	                    { id: '-footer', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', transform: 'translate(-1289.000000, -192.000000)' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'footer', fill: '#000000' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'facebook', transform: 'translate(1289.000000, 192.000000)' },
	                            _react2.default.createElement('path', { d: 'M15.5947,11.5 L13.4997,11.5 L13.4997,18.5 L10.4997,18.5 L10.4997,11.5 L8.4997,11.5 L8.4997,9.5 L10.4997,9.5 L10.4997,8.336 C10.4997,7.237 10.8517,5.518 13.1497,5.518 L15.4997,5.524 L15.4997,7.83 L14.0917,7.83 C13.8477,7.83 13.4997,7.954 13.4997,8.477 L13.4997,9.5 L15.8387,9.5 L15.5947,11.5 Z M11.9997,0 C5.3827,0 -0.0003,5.383 -0.0003,12 C-0.0003,18.617 5.3827,24 11.9997,24 C18.6167,24 23.9997,18.617 23.9997,12 C23.9997,5.383 18.6167,0 11.9997,0 L11.9997,0 Z', id: 'Fill-403' })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'a',
	            { href: 'https://www.instagram.com/globalcitizenyr/', target: '_blank', className: _FooterNewModule2.default.HoverItem__Instagram },
	            _react2.default.createElement(
	                'svg',
	                { width: '24px', height: '24px', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: '-footer', transform: 'translate(-1187.000000, -192.000000)' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'Group-2', transform: 'translate(1187.000000, 192.000000)' },
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Instagram' },
	                                _react2.default.createElement('path', { d: 'M0,12 C0,5.37258267 5.37258267,0 12,0 C18.6274173,0 24,5.37258267 24,12 C24,18.6274173 18.6274173,24 12,24 C5.37258267,24 0,18.6274173 0,12 Z', id: 'path-1' }),
	                                _react2.default.createElement('path', { d: 'M12.0006,5.6 C10.2624486,5.6 10.044313,5.60760008 9.36163918,5.63866707 C8.68029875,5.66986739 8.21522724,5.77773518 7.80828967,5.9360035 C7.38735195,6.09947187 7.03028157,6.31814081 6.67454453,6.67401119 C6.31854082,7.02974823 6.09987187,7.38681861 5.93587017,7.807623 C5.77720185,8.2146939 5.66920072,8.67989875 5.63853373,9.36097251 C5.60800008,10.0436463 5.6,10.2619152 5.6,12.0000667 C5.6,13.7382181 5.60773341,13.955687 5.63866707,14.6383608 C5.67000073,15.3197012 5.77786852,15.7847728 5.9360035,16.1917103 C6.0996052,16.612648 6.31827415,16.9697184 6.67414452,17.3254555 C7.02974823,17.6814592 7.38681861,17.9006615 7.80748966,18.0641298 C8.2146939,18.2223981 8.67989875,18.3302659 9.36110584,18.3614663 C10.0437796,18.3925333 10.2617819,18.4001333 11.9998,18.4001333 C13.7380848,18.4001333 13.9555537,18.3925333 14.6382275,18.3614663 C15.3195679,18.3302659 15.7851728,18.2223981 16.192377,18.0641298 C16.6131814,17.9006615 16.9697184,17.6814592 17.3253221,17.3254555 C17.6813258,16.9697184 17.8999948,16.612648 18.0639965,16.1918437 C18.2213315,15.7847728 18.3293326,15.3195679 18.3613329,14.6384942 C18.3919999,13.9558204 18.4,13.7382181 18.4,12.0000667 C18.4,10.2619152 18.3919999,10.0437796 18.3613329,9.36110584 C18.3293326,8.67976541 18.2213315,8.2146939 18.0639965,7.80775633 C17.8999948,7.38681861 17.6813258,7.02974823 17.3253221,6.67401119 C16.9693184,6.31800748 16.6133147,6.09933853 16.191977,5.9360035 C15.7839727,5.77773518 15.3186346,5.66986739 14.6372941,5.63866707 C13.9546204,5.60760008 13.7372848,5.6 11.9986,5.6 L12.0006,5.6 Z M11.4264607,6.75334535 C11.5968625,6.75307868 11.7869978,6.75334535 12.0006,6.75334535 C13.7094178,6.75334535 13.9119532,6.75947874 14.5867603,6.79014573 C15.2107668,6.81867936 15.549437,6.92294711 15.7750393,7.01054803 C16.0737091,7.12654923 16.2866447,7.26521735 16.5105137,7.48921968 C16.734516,7.71322201 16.8731841,7.92655757 16.989452,8.22522735 C17.0770529,8.45056303 17.181454,8.78923322 17.2098543,9.41323972 C17.2405213,10.0879134 17.247188,10.2905822 17.247188,11.9986 C17.247188,13.7066178 17.2405213,13.9092866 17.2098543,14.5839602 C17.1813206,15.2079667 17.0770529,15.5466369 16.989452,15.7719726 C16.8734508,16.0706424 16.734516,16.2833113 16.5105137,16.5071803 C16.2865113,16.7311826 16.0738424,16.8698507 15.7750393,16.9858519 C15.5497036,17.0738529 15.2107668,17.1778539 14.5867603,17.2063876 C13.9120866,17.2370546 13.7094178,17.2437213 12.0006,17.2437213 C10.2916489,17.2437213 10.0891134,17.2370546 9.41443973,17.2063876 C8.79043323,17.1775873 8.45176304,17.0733195 8.22602735,16.9857186 C7.92735758,16.8697174 7.71402202,16.7310493 7.49001969,16.5070469 C7.26601735,16.2830446 7.12734924,16.0702424 7.01108137,15.7714393 C6.92348045,15.5461036 6.81907937,15.2074334 6.79067907,14.5834269 C6.76001208,13.9087532 6.75387869,13.7060844 6.75387869,11.997 C6.75387869,10.2879155 6.76001208,10.0863134 6.79067907,9.4116397 C6.8192127,8.7876332 6.92348045,8.44896301 7.01108137,8.22336066 C7.12708257,7.92469088 7.26601735,7.71135533 7.49001969,7.48735299 C7.71402202,7.26335066 7.92735758,7.12468255 8.22602735,7.00841467 C8.4516297,6.92041375 8.79043323,6.81641267 9.41443973,6.78774571 C10.0048459,6.76107876 10.2336483,6.75307868 11.4264607,6.75174533 L11.4264607,6.75334535 Z M15.4169023,7.81602308 C14.9928978,7.81602308 14.6488943,8.15962666 14.6488943,8.58376441 C14.6488943,9.00776883 14.9928978,9.35177241 15.4169023,9.35177241 C15.8409067,9.35177241 16.1849103,9.00776883 16.1849103,8.58376441 C16.1849103,8.15976 15.8409067,7.81575641 15.4169023,7.81575641 L15.4169023,7.81602308 Z M12.0006,8.71336576 C10.1855144,8.71336576 8.7138991,10.1849811 8.7138991,12.0000667 C8.7138991,13.8151522 10.1855144,15.2861009 12.0006,15.2861009 C13.8156856,15.2861009 15.2867676,13.8151522 15.2867676,12.0000667 C15.2867676,10.1849811 13.8155522,8.71336576 12.0004667,8.71336576 L12.0006,8.71336576 Z M12.0006,9.86671111 C13.1787456,9.86671111 14.1339556,10.8217877 14.1339556,12.0000667 C14.1339556,13.1782123 13.1787456,14.1334222 12.0006,14.1334222 C10.8223211,14.1334222 9.86724445,13.1782123 9.86724445,12.0000667 C9.86724445,10.8217877 10.8223211,9.86671111 12.0006,9.86671111 L12.0006,9.86671111 Z', id: 'Shape', fill: '#FFFFFF', mask: 'url(#mask-2)' })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'a',
	            { href: 'https://www.youtube.com/user/GlobalCitizenYearVid', target: '_blank', className: _FooterNewModule2.default.HoverItem__Youtube },
	            _react2.default.createElement(
	                'svg',
	                { width: '24px', height: '24px', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: '-footer', transform: 'translate(-1221.000000, -192.000000)' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'Group-2', transform: 'translate(1187.000000, 192.000000)' },
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Youtube', transform: 'translate(34.000000, 0.000000)' },
	                                _react2.default.createElement('path', { d: 'M0,11.8032787 C0,5.28450755 5.29214412,0 11.8203354,0 C18.3485268,0 23.6406709,5.28450755 23.6406709,11.8032787 C23.6406709,18.3220498 18.3485268,23.6065574 11.8203354,23.6065574 C5.29214412,23.6065574 0,18.3220498 0,11.8032787 Z', id: 'back', fill: '#000000' }),
	                                _react2.default.createElement('path', { d: 'M17.972459,9.42741457 C17.972459,9.42741457 17.8493115,8.54087071 17.472,8.15046976 C16.9931803,7.63784236 16.4565246,7.63543 16.210623,7.60567751 C14.4487869,7.47540984 11.8060328,7.47540984 11.8060328,7.47540984 L11.8005246,7.47540984 C11.8005246,7.47540984 9.15777049,7.47540984 7.39593443,7.60567751 C7.14963934,7.63543 6.61337705,7.63784236 6.13416393,8.15046976 C5.75685246,8.54087071 5.63409836,9.42741457 5.63409836,9.42741457 C5.63409836,9.42741457 5.50819672,10.4687518 5.50819672,11.509687 L5.50819672,12.4858904 C5.50819672,13.5272276 5.63409836,14.5681628 5.63409836,14.5681628 C5.63409836,14.5681628 5.75685246,15.4547066 6.13416393,15.8451076 C6.61337705,16.357735 7.2424918,16.3416525 7.52262295,16.3951266 C8.52983607,16.4940336 11.8032787,16.5245902 11.8032787,16.5245902 C11.8032787,16.5245902 14.4487869,16.5205696 16.210623,16.3903019 C16.4565246,16.3601473 16.9931803,16.357735 17.472,15.8451076 C17.8493115,15.4547066 17.972459,14.5681628 17.972459,14.5681628 C17.972459,14.5681628 18.0983607,13.5272276 18.0983607,12.4858904 L18.0983607,11.509687 C18.0983607,10.4687518 17.972459,9.42741457 17.972459,9.42741457 L17.972459,9.42741457 Z', fill: '#FFFFFF' }),
	                                _react2.default.createElement('polygon', { id: 'Path', fill: '#000000', points: '10.5033443 13.668753 10.5029508 10.0538251 13.9046557 11.867521' })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'a',
	            { href: 'https://www.snapchat.com/add/globalcitizenyr', target: '_blank', className: _FooterNewModule2.default.HoverItem__Snapchat },
	            _react2.default.createElement(
	                'svg',
	                { width: '24px', height: '24px', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: '-footer', transform: 'translate(-1255.000000, -192.000000)' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'Group-2', transform: 'translate(1187.000000, 192.000000)' },
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Snapchat', transform: 'translate(68.000000, 0.000000)' },
	                                _react2.default.createElement('path', { d: 'M0,11.8032787 C0,5.28450755 5.29214412,0 11.8203354,0 C18.3485268,0 23.6406709,5.28450755 23.6406709,11.8032787 C23.6406709,18.3220498 18.3485268,23.6065574 11.8203354,23.6065574 C5.29214412,23.6065574 0,18.3220498 0,11.8032787 Z', id: 'back', fill: '#000000' }),
	                                _react2.default.createElement('path', { d: 'M11.9243331,5.90163934 L11.9237784,5.90163934 C11.9129133,5.90163934 11.9027007,5.90163934 11.8929776,5.90176948 C11.8154534,5.90255027 11.6880083,5.90378654 11.6765558,5.90391667 C11.3970641,5.90391667 10.8378522,5.94328186 10.2371701,6.20764678 C9.8937274,6.3586985 9.58480517,6.56294204 9.3190172,6.8147166 C9.00213374,7.11470539 8.74398073,7.48457553 8.55186686,7.91420919 C8.27051533,8.54327146 8.33730491,9.60284579 8.3909454,10.4543377 L8.39114117,10.4556715 C8.3968837,10.5468621 8.40291989,10.6420869 8.40843403,10.7348716 C8.36715956,10.7537734 8.30023946,10.7737163 8.20160492,10.7737163 C8.04290216,10.7737163 7.85418161,10.7231271 7.64082689,10.6234453 C7.57805056,10.5942956 7.50639939,10.579558 7.42734167,10.579558 C7.30032073,10.579558 7.16641528,10.6168411 7.05025947,10.6849331 C6.90411851,10.7704955 6.80969298,10.8914214 6.78404734,11.0254908 C6.76714602,11.1141764 6.76796172,11.2894653 6.96324051,11.4672268 C7.070652,11.5650867 7.22844117,11.6553339 7.43210536,11.7355933 C7.48555008,11.7565773 7.54897898,11.7766177 7.6161601,11.7978619 C7.8492874,11.8717448 8.20212697,11.9833663 8.29413802,12.1992893 C8.34076348,12.3087635 8.32069724,12.4528206 8.23465712,12.6269384 C8.23240578,12.6316882 8.23015445,12.6363405 8.22809888,12.6412205 C8.20659701,12.6912891 8.00599985,13.1443467 7.59452771,13.622162 C7.36071522,13.8938794 7.10318215,14.1209613 6.82949819,14.2972913 C6.49545238,14.5125636 6.13399902,14.6533023 5.75528542,14.7155058 C5.60656684,14.7398407 5.50036259,14.8719581 5.50865011,15.0220989 C5.5111951,15.065368 5.52137505,15.1085071 5.53902681,15.1502472 C5.53915733,15.1505075 5.53932047,15.1507677 5.53945098,15.1509955 C5.59958445,15.2912462 5.73900404,15.4103828 5.96567099,15.5154651 C6.24265037,15.6437436 6.65689589,15.7516562 7.19679198,15.8360799 C7.22406901,15.8878078 7.25239015,16.0178105 7.27199959,16.1068214 C7.29252263,16.201428 7.31392662,16.2987023 7.34443383,16.4020278 C7.37735552,16.5139746 7.46274308,16.6477512 7.68210136,16.6477512 C7.76523759,16.6477512 7.86083773,16.6290771 7.97154465,16.6076702 C8.13367335,16.5759504 8.35538084,16.5326812 8.6320992,16.5326812 C8.78551622,16.5326812 8.94451263,16.5461499 9.10455314,16.5726645 C9.4130512,16.6238718 9.67900231,16.811198 9.9867173,17.0281295 C10.4371147,17.3455887 10.9469277,17.704918 11.7258568,17.704918 C11.7470976,17.704918 11.7684037,17.7042348 11.7894488,17.7027708 C11.8151923,17.7039746 11.8471026,17.704918 11.8807747,17.704918 C12.6599321,17.704918 13.1696147,17.3454585 13.6195226,17.0282597 L13.6202404,17.027609 C13.9280207,16.8109378 14.1936781,16.6238718 14.5020783,16.5726645 C14.6620536,16.5461825 14.8210174,16.5326812 14.9744996,16.5326812 C15.238852,16.5326812 15.4481608,16.566288 15.6350542,16.6026276 C15.7570178,16.626572 15.8518022,16.6380888 15.9245301,16.6380888 L15.931643,16.6382189 L15.9390169,16.6382189 C16.099449,16.6382189 16.2173341,16.5504118 16.2623281,16.3967574 C16.2922154,16.2956116 16.3135542,16.2006146 16.3345992,16.1044139 C16.3529362,16.0209987 16.3822362,15.8872872 16.4095132,15.8350063 C16.9497682,15.75042 17.3638506,15.642735 17.6408626,15.5144891 C17.8670075,15.4098948 18.0062639,15.2908883 18.0667563,15.1512232 C18.0848975,15.109353 18.0955016,15.0659536 18.0978835,15.0217735 C18.1063994,14.871893 18.000032,14.7395153 17.8512155,14.7151805 C16.1680984,14.4385831 15.4098555,12.7141925 15.3784999,12.6409277 C15.376477,12.6361128 15.374193,12.6313304 15.3718112,12.6266781 C15.2857711,12.4524953 15.2659006,12.3086009 15.3125587,12.1989314 C15.404374,11.9832036 15.7569851,11.8715822 15.9902756,11.7977318 C16.0578156,11.7765201 16.1214729,11.7563495 16.1744935,11.7354632 C16.4041622,11.6450209 16.5683138,11.5469007 16.6766063,11.4354744 C16.8059438,11.3026413 16.8311327,11.1753713 16.8295665,11.0920863 C16.8256185,10.8905756 16.6711248,10.7115127 16.4253704,10.6238357 C16.3423647,10.5896108 16.2477108,10.5715548 16.1513276,10.5715548 C16.0857126,10.5715548 15.9885463,10.580534 15.8965679,10.6233477 C15.6996577,10.7152215 15.5232705,10.7654528 15.3718438,10.7726101 C15.2913178,10.7685435 15.2348387,10.7511382 15.1982627,10.7345137 C15.2028632,10.6559135 15.2079532,10.575166 15.2132063,10.4909701 L15.2153924,10.4549233 C15.2693265,9.60287832 15.3363445,8.54249066 15.0548625,7.91297292 C14.8619329,7.4818102 14.6028663,7.1109966 14.2847104,6.81035715 C14.0178783,6.55841992 13.707912,6.35420892 13.3632294,6.20325479 C12.7633956,5.94084187 12.2042164,5.90163934 11.9243331,5.90163934', fill: '#FFFFFF' })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'a',
	            { href: 'https://www.linkedin.com/company/global-citizen-year', target: '_blank', className: _FooterNewModule2.default.HoverItem__Linkedin },
	            _react2.default.createElement(
	                'svg',
	                { width: '24px', height: '24px', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: '-footer', transform: 'translate(-1289.000000, -192.000000)' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'Group-2', transform: 'translate(1187.000000, 192.000000)' },
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'LinkedIN', transform: 'translate(102.000000, 0.000000)' },
	                                _react2.default.createElement('path', { d: 'M0,12 C0,5.37258267 5.37258267,0 12,0 C18.6274173,0 24,5.37258267 24,12 C24,18.6274173 18.6274173,24 12,24 C5.37258267,24 0,18.6274173 0,12 Z', id: 'back', fill: '#000000' }),
	                                _react2.default.createElement('path', { d: 'M8.48027098,9.93892416 L8.48027098,18.1097799 L5.76080857,18.1097799 L5.76080857,9.93892416 L8.48027098,9.93892416 Z M8.65938164,7.41134885 C8.65938164,8.19590154 8.06882698,8.82367385 7.12059408,8.82367385 L7.10321525,8.82367385 C6.19022881,8.82367385 5.6,8.19590154 5.6,7.41134885 C5.6,6.61020162 6.20820505,6 7.13851601,6 C8.06882698,6 8.64173126,6.61020162 8.65938164,7.41134885 Z M18.2876928,13.4248609 L18.2875842,18.1097799 L15.5682304,18.1097799 L15.5682304,13.7383675 C15.5682304,12.6403625 15.1747083,11.8911138 14.1902514,11.8911138 C13.4389425,11.8911138 12.9914374,12.3962167 12.7948936,12.8840743 C12.7229886,13.0589135 12.7053382,13.3025169 12.7053382,13.5467169 L12.7053382,18.1099968 L9.98554997,18.1099968 C9.98554997,18.1099968 10.0213938,10.7058519 9.98554997,9.93914108 L12.7053382,9.93914108 L12.7053382,11.0964743 C13.066275,10.5401235 13.7127135,9.74705663 15.1565691,9.74705663 C16.9461008,9.74705663 18.2876928,10.9151274 18.2876928,13.4248609 Z', id: 'Shape', fill: '#FFFFFF' })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Social;
	module.exports = exports['default'];

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Logo":"src-components-Header----Header-module---Logo---2JglE","dropdown":"src-components-Header----Header-module---dropdown---2rbPP","MobileToggle":"src-components-Header----Header-module---MobileToggle---20l5K","mobileDisplay":"src-components-Header----Header-module---mobileDisplay---1-Npc","Header":"src-components-Header----Header-module---Header---1IKFS","Header__Hidden":"src-components-Header----Header-module---Header__Hidden---2lACe","submenu":"src-components-Header----Header-module---submenu---3JctB","subItemShow":"src-components-Header----Header-module---subItemShow---1KAOy","ApplyButton":"src-components-Header----Header-module---ApplyButton---2C-mn","Header__Fixed":"src-components-Header----Header-module---Header__Fixed---1L2ZE","Header__Black":"src-components-Header----Header-module---Header__Black---qEEET","submenu__mobile":"src-components-Header----Header-module---submenu__mobile---2xgHM","Nav":"src-components-Header----Header-module---Nav---17sK6","Open":"src-components-Header----Header-module---Open---1UtJ2","ApplyButton__Wrapper":"src-components-Header----Header-module---ApplyButton__Wrapper---LnyMI","Nav__Item":"src-components-Header----Header-module---Nav__Item---3JfAB","Nav__mobile":"src-components-Header----Header-module---Nav__mobile---1_npc","Hide__Desktop":"src-components-Header----Header-module---Hide__Desktop---3o75G","growHeight":"src-components-Header----Header-module---growHeight---uk_aw","linkSlide":"src-components-Header----Header-module---linkSlide---wCgdg"};

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactTransitionGroup = __webpack_require__(112);
	
	var _Browser = __webpack_require__(347);
	
	var _HeaderModule = __webpack_require__(729);
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
		_inherits(Header, _React$Component);
	
		function Header(props) {
			_classCallCheck(this, Header);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.state = {
				headerFixed: false,
				mobileToggle: false,
				headerBlack: null,
				activeSubmenu: false,
				hideApply: false,
				hideBanner: true,
				hideNav: false,
				globalRemoveBanner: true
			};
	
			_this.stickyHeader = _this.stickyHeader.bind(_this);
			_this.mobileNavToggle = _this.mobileNavToggle.bind(_this);
			return _this;
		}
	
		Header.prototype.componentDidMount = function componentDidMount() {
			var stickyHidingTimeout = true;
			this.stickyHeader(stickyHidingTimeout);
			this.locationUpdate();
		};
	
		Header.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
			var pathname = window.location.pathname;
			var location = this.state.location;
	
			pathname != location ? this.locationUpdate(prevState) : null;
		};
	
		Header.prototype.locationUpdate = function locationUpdate(prevState) {
			var pathname = window.location.pathname.split('/');
			var disabledPages = ['/academy/apply/', '/academy/apply'];
			var links = ['careers', 'success-stories', 'program-overview', 'destinations-overview', 'destinations', 'destination', 'updates', 'fellow-stories', 'fellows', 'our-team', 'academy-faq', 'fellowship-faq', 'admissions', 'author', 'what-about-college', 'content', 'advisory-council', 'program-overview', 'apply-now', 'news', 'press', 'financial-aid-tuition', 'about', 'interest-form', 'ambassador', 'for-educators', 'parents', 'family-portal', 'thank-you-for-your-interest', 'thank-you', 'partners-and-supporters', 'gap-year-resources', '2018', 'parent-interest', 'gap-year-celebrity-quiz', 'should-i-take-a-gap-year-quiz', 'gap-year-personality-quiz', 'gap-year-bff-quiz', 'what-type-of-gap-year-quiz', 'apply-10710', 'apply', 'welcome-quiz', 'formulario', 'congrats', 'submitted', 'apprenticeship-quiz', 'nominate-a-student', 'donate', 'donate-staging', 'tech-for-good-scholarship', 'parent-request-info', 'institute', 'refer', 'thank-you-institute-info', 'thank-you-academy-info', 'privacy-policy', 'mentorapplication', 'redesign-home', 'academy-stories', '/academy/admissions/', '/academy/tuition/', '/academy/speakers/', '/academy/final-clearance-instructions', 'our-impact-staging', 'our-impact', 'tuition-and-aid', '/academy/past-speakers/'];
	
			// console.log('THE HOME LOCATION ==== ', this.props.location.pathname, this.props.location);
			// console.log('HOME LOC ', this.props.location.pathname);
			if (this.state.location !== this.props.location.pathname) {
				if (links.includes(pathname[1]) || this.props.location.pathname === '/' || links.includes(this.props.location.pathname)) {
					this.setState({
						headerBlack: true,
						location: this.props.location.pathname
					});
				} else {
					this.setState({
						headerBlack: false,
						location: this.props.location.pathname
					});
				}
			}
	
			if (disabledPages.includes(window.location.pathname)) {
				if (this.state.hideNav === false) {
					this.setState({
						hideNav: true
					});
				}
			} else {
				if (this.state.hideNav === true) {
					this.setState({
						hideNav: false
					});
				}
			}
	
			// if (
			// 	links.includes(pathname[1]) ||
			// 	pathname[1] === 'apprenticeship' ||
			// 	pathname[1] == 'author' ||
			// 	pathname[1] == ''
			// ) {
			// 	if( this.state.location !== window.location.pathname ) {
			// 		this.setState({
			// 			headerBlack: true,
			// 			location: window.location.pathname
			// 		})
			// 	}
			// } else {
			// 	// NOTE: If this check removed header gets stuck
			// 	// 		in a performance draining loop trying to
			// 	//		continually reset state.
			// 	if( this.state.headerBlack !== false ) {
			// 		this.setState({ headerBlack: false })
			// 	}
			// }
	
			if (pathname[1] == 'careers') {
				if (this.state.hideApply !== true) {
					this.setState({
						hideApply: false
					});
				}
			} else {
				if (this.state.hideApply !== false) {
					this.setState({ hideApply: false });
				}
			}
	
			if (pathname[1] == 'thank-you-institute-info' || pathname[1] == 'mentorapplication') {
				if (this.state.hideBanner === false) {
					this.setState({ hideBanner: true });
				}
			} else {
				if (this.state.hideBanner === true) {
					this.setState({ hideBanner: false });
				}
			}
	
			document.body.classList.remove('home');
			document.body.style.marginTop = '';
	
			if (!this.state.globalRemoveBanner) document.body.classList.remove('banner-top');
	
			if (pathname[1] == '' || pathname[1] == 'about-us') {
				if (!this.state.globalRemoveBanner) {
					document.body.classList.add('banner-top');
					document.body.style.marginTop = '80px';
					// document.body.style.marginTop = '0px'
				}
			} else if (pathname[1] == 'home-staging' || pathname[1] == 'home-staging-2') {
				document.body.style.marginTop = '0';
				document.body.classList.add('home');
			}
			// else if (pathname[2] == 'apply') {
			// 	document.body.style.marginTop = 0
			// }
			// else {
			// 	document.body.style.marginTop = '0px'
			// }
	
	
			//console.log(pathname[1], this.state.hideApply)
		};
	
		Header.prototype.stickyHeader = function stickyHeader(stickyHidingTimeout) {
			var _this2 = this;
	
			var trigger = 65,
			    header = document.querySelector('#header');
	
			window.addEventListener('scroll', function () {
				var doc = document.documentElement,
				    top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
	
				if (top > trigger) {
					_this2.setState({
						headerFixed: true
					}, function () {
						stickyHidingTimeout = false;
					});
				} else {
					if (_this2.state.mobileToggle === false) {
						_this2.setState({
							headerFixed: false
						}, function () {
							stickyHidingTimeout = true;
						});
					}
				}
			});
		};
	
		Header.prototype.mobileNavToggle = function mobileNavToggle() {
			var trigger = 65,
			    header = document.querySelector('#header'),
			    top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
	
			if (this.state.mobileToggle === false) {
				this.setState({
					mobileToggle: true,
					headerFixed: true
				});
			} else {
				if (top > trigger) {
					this.setState({
						mobileToggle: false,
						headerFixed: true
					});
				} else {
					this.setState({
						mobileToggle: false,
						headerFixed: false
					});
				}
			}
		};
	
		Header.prototype.handleMouseEnter = function handleMouseEnter(index, e) {
			this.setState({
				activeSubmenu: index,
				headerFixed: true
			});
		};
	
		Header.prototype.handleMouseLeave = function handleMouseLeave() {
			this.setState({
				activeSubmenu: false
			});
		};
	
		Header.prototype.handleNavClick = function handleNavClick(e) {
			var _this3 = this;
	
			e.stopPropagation();
			if (_Browser.mobileos) {
				this.setState({
					activeSubmenu: false,
					mobileToggle: false
				}, function () {
					return _this3.forceUpdate();
				});
			} else {
				this.handleMouseLeave();
			}
		};
	
		Header.prototype.render = function render() {
			var _this4 = this;
	
			return _react2.default.createElement(
				'div',
				{
					className: _HeaderModule2.default.Header + ' ' + (this.state.headerFixed && _HeaderModule2.default.Header__Fixed) + ' ' + (this.state.headerBlack && _HeaderModule2.default.Header__Black) + ' ' + (this.state.headerFixed && ' fixed') + ' ' + (this.state.hideNav && _HeaderModule2.default.Header__Hidden) + ' ' + this.props.location.pathname.split('/')[1] + '-header',
					id: 'header'
				},
				_react2.default.createElement(
					_gatsbyLink2.default,
					{ to: '/', className: '' + _HeaderModule2.default.Logo },
					this.state.headerBlack && this.props.location.pathname != '/' && !this.state.headerFixed && _react2.default.createElement('img', { src: '/images/redesign/global-citizen-year-new-logo.svg', alt: 'Global Citizen Year Logo' }),
					(!this.state.headerBlack || this.props.location.pathname == '/') && !this.state.headerFixed && _react2.default.createElement('img', { src: '/images/redesign/global-citizen-year-new-logo-white.svg', alt: '' }),
					this.state.headerFixed && _react2.default.createElement('img', { src: '/images/redesign/global-citizen-year-new-logo.svg', alt: 'Global Citizen Year Logo' })
				),
				this.state.activeSubmenu !== false && _Browser.mobileos && _react2.default.createElement(
					'div',
					{ className: 'flex back-to-main', onClick: function onClick(e) {
							return _this4.handleMouseLeave(2, e);
						} },
					_react2.default.createElement(
						'p',
						{ className: 'h3' },
						'Back'
					)
				),
				!this.state.hideApply && !this.state.mobileToggle && _react2.default.createElement(
					'div',
					{
						className: _HeaderModule2.default.Hide__Desktop + ' ' + _HeaderModule2.default.Nav__Item + ' ' + _HeaderModule2.default.ApplyButton__Wrapper
					},
					_react2.default.createElement(
						_gatsbyLink2.default,
						{
							to: '/#signup',
							className: _HeaderModule2.default.ApplyButton + ' button button--small',
							onClick: function onClick(e) {
								return _this4.handleNavClick(e);
							},
							target: '_blank'
						},
						'Request Info'
					)
				),
				_react2.default.createElement(
					'div',
					{
						className: _HeaderModule2.default.MobileToggle + ' ' + (_Browser.mobileos && _HeaderModule2.default.mobileDisplay),
						onClick: function onClick() {
							return _this4.mobileNavToggle();
						},
						style: this.state.mobileToggle ? { backgroundColor: '#F9F9F8' } : {}
					},
					this.state.mobileToggle ? _react2.default.createElement('img', { src: '/images/icon-close.svg', alt: 'menu icon' }) : _react2.default.createElement('img', { src: '/images/icon-menu.svg', alt: 'close icon' })
				),
				_react2.default.createElement(
					'div',
					{
						className: _HeaderModule2.default.Nav + ' ' + (this.state.mobileToggle && _HeaderModule2.default.Open) + ' ' + (_Browser.mobileos && _HeaderModule2.default.Nav__mobile)
					},
					_react2.default.createElement(
						'div',
						{
							className: _HeaderModule2.default.Nav__Item,
							onClick: function onClick(e) {
								if (_Browser.mobileos) {
									_this4.handleMouseEnter(2, e);
								}
							},
							onMouseEnter: function onMouseEnter(e) {
								_this4.handleMouseEnter(2, e);
							},
							onMouseLeave: function onMouseLeave(e) {
								_this4.handleMouseLeave(2, e);
							}
						},
						_react2.default.createElement(
							_gatsbyLink2.default,
							{
								to: '/academy/',
								onClick: function onClick(e) {
									return _Browser.mobileos ? e.preventDefault() : _this4.handleNavClick(e);
								}
							},
							'Programs'
						),
						this.state.activeSubmenu == 2 && _react2.default.createElement(
							'ul',
							{
								className: 'sub-menu ' + _HeaderModule2.default.submenu + ' ' + (this.state.headerBlack && _HeaderModule2.default.Header__Black) + ' ' + (_Browser.mobileos && _HeaderModule2.default.submenu__mobile) + ' mega-menu'
							},
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'flex' },
									_react2.default.createElement(
										'h3',
										{ className: 'h3 headline-with-accent green' },
										'The Academy'
									),
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: '/academy/', className: 'hoverlink', onClick: function onClick(e) {
												return _this4.handleNavClick(e);
											} },
										'Learn More'
									)
								),
								_react2.default.createElement(
									'p',
									{ className: 'excerpt' },
									'An intensive, 12-week leadership experience that equips students worldwide with powerful skills for a lifetime of social impact. Designed as a 7-10 hour per week commitment, the Academy adds an enriching layer of purpose to high school, college, travel, or work.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'link-container' },
									_react2.default.createElement(
										'div',
										{ className: 'item' },
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: '/experience/academy-experience/', onClick: function onClick(e) {
													return _this4.handleNavClick(e);
												} },
											_react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/5w9g7mPCqgWYKtrEEbedq0/f122f3d796ec269f696fbf3cdce2a854/academy-experience.jpg', alt: '' })
										),
										_react2.default.createElement(
											'p',
											{ className: 'title' },
											_react2.default.createElement(
												_gatsbyLink2.default,
												{ to: '/experience/academy-experience/', onClick: function onClick(e) {
														return _this4.handleNavClick(e);
													} },
												'The Experience'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'item' },
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: '/academy/speakers/', onClick: function onClick(e) {
													return _this4.handleNavClick(e);
												} },
											_react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/5FaE7EsGlL8JjEXfplAQuX/9ede9f07b8cfcdf7c45f64d719bbc381/The_Speakers.png', alt: '' })
										),
										_react2.default.createElement(
											'p',
											{ className: 'title' },
											_react2.default.createElement(
												_gatsbyLink2.default,
												{ to: '/academy/speakers/', onClick: function onClick(e) {
														return _this4.handleNavClick(e);
													} },
												'The Speakers'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'item' },
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: '/academy-stories/', onClick: function onClick(e) {
													return _this4.handleNavClick(e);
												} },
											_react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/1A4IIARwAZjhYdKTAXPcqc/c31ab9b66e64cca9f3daa9850a2d06e4/Academy_Stories.jpg', alt: '' })
										),
										_react2.default.createElement(
											'p',
											{ className: 'title' },
											_react2.default.createElement(
												_gatsbyLink2.default,
												{ to: '/academy-stories/', onClick: function onClick(e) {
														return _this4.handleNavClick(e);
													} },
												'Academy Stories'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'item' },
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: '/academy-faq/', onClick: function onClick(e) {
													return _this4.handleNavClick(e);
												} },
											_react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/2Tl6kBhXjQ05kKLDfYwZtd/7ff2c0d12da0c31b18e278d8e6e5416d/Academy_FAQs.jpg', alt: '' })
										),
										_react2.default.createElement(
											'p',
											{ className: 'title' },
											_react2.default.createElement(
												_gatsbyLink2.default,
												{ to: '/academy-faq/', onClick: function onClick(e) {
														return _this4.handleNavClick(e);
													} },
												'FAQs'
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'flex' },
									_react2.default.createElement(
										'h3',
										{ className: 'h3 headline-with-accent blue' },
										'The Fellowship'
									),
									_react2.default.createElement(
										_gatsbyLink2.default,
										{
											to: '/fellowship/',
											className: 'hoverlink',
											onClick: function onClick(e) {
												return _Browser.mobileos ? _this4.mobileNavToggle() : _this4.handleNavClick(e);
											} },
										'Learn More'
									)
								),
								_react2.default.createElement(
									'p',
									{ className: 'excerpt' },
									'A deep, 8-month immersion where students live alongside the global majority in Brazil, Ecuador or India and develop the insights, skills, and network to become the leaders our world needs. Fellows build language fluency, develop resilience, and become part of a community a world away from home.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'link-container' },
									_react2.default.createElement(
										'div',
										{ className: 'item' },
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: '/experience/fellowship-experience/', onClick: function onClick(e) {
													return _this4.handleNavClick(e);
												} },
											_react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/3ZLa7eOphapeDbxDCA7lXP/84640656fbcc91829a5350fadac26baf/fellowship-experience.jpg', alt: '' })
										),
										_react2.default.createElement(
											'p',
											{ className: 'title' },
											_react2.default.createElement(
												_gatsbyLink2.default,
												{ to: '/experience/fellowship-experience/', onClick: function onClick(e) {
														return _this4.handleNavClick(e);
													} },
												'The Experience'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'item' },
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: '/destinations-overview/', onClick: function onClick(e) {
													return _this4.handleNavClick(e);
												} },
											_react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/1CmKtDHRwbB7DbxwsrFrvG/be986a08ad70cedd262be08095a75e76/fellowship-destination.jpg', alt: '' })
										),
										_react2.default.createElement(
											'p',
											{ className: 'title' },
											_react2.default.createElement(
												_gatsbyLink2.default,
												{ to: '/destinations-overview/', onClick: function onClick(e) {
														return _this4.handleNavClick(e);
													} },
												'Destinations'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'item' },
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: '/fellow-stories/', onClick: function onClick(e) {
													return _this4.handleNavClick(e);
												} },
											_react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/jBjZyu2QV2wtUtv4bXVnJ/e8274d0979707deec42eaa414b69b78c/Fellowship_Stories.jpg', alt: '' })
										),
										_react2.default.createElement(
											'p',
											{ className: 'title' },
											_react2.default.createElement(
												_gatsbyLink2.default,
												{ to: '/fellow-stories/', onClick: function onClick(e) {
														return _this4.handleNavClick(e);
													} },
												'Fellowship Stories'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'item' },
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: '/fellowship-faq/', onClick: function onClick(e) {
													return _this4.handleNavClick(e);
												} },
											_react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/7xbGbNViJecHKdR8kRox6i/aa29c9c77fb6f9675c1b3bbf8b6da005/Fellowship_FAQs.jpg', alt: '' })
										),
										_react2.default.createElement(
											'p',
											{ className: 'title' },
											_react2.default.createElement(
												_gatsbyLink2.default,
												{ to: '/fellowship-faq/', onClick: function onClick(e) {
														return _this4.handleNavClick(e);
													} },
												'FAQs'
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'li',
								{ className: 'banner' },
								_react2.default.createElement(
									'p',
									null,
									'Not sure which program is right for you? ',
									_react2.default.createElement(
										'a',
										{ href: 'https://globalcitizenyear.typeform.com/to/qrmrqkgz/', onClick: function onClick(e) {
												return _this4.handleNavClick(e);
											}, target: '_blank' },
										'Take the Quiz'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{
							className: _HeaderModule2.default.Nav__Item,
							onClick: function onClick(e) {
								if (_Browser.mobileos) {
									_this4.handleMouseEnter(4, e);
								}
							},
							onMouseEnter: function onMouseEnter(e) {
								_this4.handleMouseEnter(4, e);
							},
							onMouseLeave: function onMouseLeave(e) {
								_this4.handleMouseLeave(4, e);
							}
						},
						_react2.default.createElement(
							_gatsbyLink2.default,
							{
								to: '/admissions/',
								onClick: function onClick(e) {
									return _Browser.mobileos ? e.preventDefault() : _this4.handleNavClick(e);
								}
							},
							'Admissions'
						),
						this.state.activeSubmenu == 4 && _react2.default.createElement(
							'ul',
							{
								className: _HeaderModule2.default.submenu + ' ' + (this.state.headerBlack && _HeaderModule2.default.Header__Black) + ' ' + (_Browser.mobileos && _HeaderModule2.default.submenu__mobile)
							},
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{
										to: '/admissions/',
										onClick: function onClick(e) {
											return _this4.handleNavClick(e);
										}
									},
									'Admissions & Tuition'
								)
							),
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{
										to: '/financial-aid-tuition/',
										onClick: function onClick(e) {
											return _this4.handleNavClick(e);
										}
									},
									'Scholarships'
								)
							),
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{
										to: '/what-about-college/',
										onClick: function onClick(e) {
											return _this4.handleNavClick(e);
										}
									},
									'What About College?'
								)
							),
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{
										to: '/#signup',
										onClick: function onClick(e) {
											return _this4.handleNavClick(e);
										}
									},
									'Request Info'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{
							className: _HeaderModule2.default.Nav__Item,
							onClick: function onClick(e) {
								if (_Browser.mobileos) {
									_this4.handleMouseEnter(5, e);
									e.stopPropagation();
								}
							},
							onMouseEnter: function onMouseEnter(e) {
								_this4.handleMouseEnter(5, e);
							},
							onMouseLeave: function onMouseLeave(e) {
								_this4.handleMouseLeave(5, e);
							}
						},
						_react2.default.createElement(
							_gatsbyLink2.default,
							{
								to: '/about-us/',
								onClick: function onClick(e) {
									return _Browser.mobileos ? e.preventDefault() : _this4.handleNavClick(e);
								}
							},
							'About Us'
						),
						this.state.activeSubmenu == 5 && _react2.default.createElement(
							'ul',
							{
								className: _HeaderModule2.default.submenu + ' ' + (this.state.headerBlack && _HeaderModule2.default.Header__Black) + ' ' + (_Browser.mobileos && _HeaderModule2.default.submenu__mobile)
							},
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/donate/' },
									'Donate'
								)
							),
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/about-us/', onClick: function onClick(e) {
											return _this4.handleNavClick(e);
										} },
									'Our Story'
								)
							),
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/our-impact/', onClick: function onClick(e) {
											return _this4.handleNavClick(e);
										} },
									'Our Impact'
								)
							),
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/our-team/', onClick: function onClick(e) {
											return _this4.handleNavClick(e);
										} },
									'Our Team'
								)
							),
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/press/', onClick: function onClick(e) {
											return _this4.handleNavClick();
										} },
									'News & Press'
								)
							),
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/success-stories/', onClick: function onClick(e) {
											return _this4.handleNavClick(e);
										} },
									'Alumni Stories'
								)
							),
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/parents/', onClick: function onClick(e) {
											return _this4.handleNavClick(e);
										} },
									'For Parents'
								)
							),
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/for-educators/', onClick: function onClick(e) {
											return _this4.handleNavClick(e);
										} },
									'For Educators'
								)
							)
						)
					),
					!this.state.hideApply && _react2.default.createElement(
						'div',
						{
							className: _HeaderModule2.default.Nav__Item + ' ' + _HeaderModule2.default.ApplyButton__Wrapper
						},
						_react2.default.createElement(
							_gatsbyLink2.default,
							{
								to: '/#signup',
								className: _HeaderModule2.default.ApplyButton + ' button button--small',
								onClick: function onClick(e) {
									return _this4.handleNavClick(e);
								},
								target: '_blank'
							},
							'Request Info'
						)
					),
					!this.state.globalRemoveBanner && !this.state.hideBanner && _react2.default.createElement(
						'div',
						{ id: 'green-banner', className: 'flex' },
						_react2.default.createElement(
							'div',
							{ className: 'left-block' },
							_react2.default.createElement(
								'h3',
								{ className: 'text-right' },
								'REGISTER TO VOTE'
							),
							_react2.default.createElement(
								'p',
								{ className: 'text-right' },
								'Take 2 minutes to register to vote at your current address.'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'right-block' },
							_react2.default.createElement(
								'a',
								{ href: 'https://www.whenweallvote.org/globalcitizenyear/', target: '_blank',
									className: 'button button-small' },
								'REGISTER NOW'
							)
						),
						_react2.default.createElement('div', { className: 'strokes', style: { background: 'url(/images/white-brushstrokes.png) center no-repeat', backgroundSize: 'contain' } })
					)
					/*<div id="green-banner" className="shawn-mendes-banner" style={{ backgroundImage: 'url(/images/HR2B.jpg)' }}>
	    	<div className="banner-content-wrap flex">
	    		<div className="left-block">
	    			<h3>We're thrilled to partner with the Shawn Mendes Foundation to launch Global Citizen Academy!</h3>
	    			<Link to="/academy/"
	    			className="button">EXPLORE THE ACADEMY</Link>
	    		</div>
	    		<div className="right-block">
	    			<img src="/images/GCA_X_SMF_blue.png" alt="Shawn Mendes Foundation logo" />
	    		</div>
	    	</div>
	    </div>*/
	
				),
				!this.state.globalRemoveBanner && !this.state.hideBanner && _react2.default.createElement(
					'div',
					{ id: 'green-banner-mobile' },
					_react2.default.createElement(
						'h3',
						null,
						'REGISTER TO VOTE'
					),
					_react2.default.createElement(
						'p',
						null,
						'Take 2 minutes to register to vote at',
						_react2.default.createElement('br', null),
						'your current address.'
					),
					_react2.default.createElement(
						'p',
						null,
						_react2.default.createElement(
							'a',
							{ href: 'https://www.whenweallvote.org/globalcitizenyear/', target: '_blank',
								className: 'button button-small' },
							'REGISTER NOW'
						)
					),
					_react2.default.createElement('div', { className: 'strokes', style: { background: 'url(/images/white-brushstrokes.png) center no-repeat', backgroundSize: 'contain' } })
				)
				/*<div id="green-banner-mobile" className="shawn-mendes-banner" style={{ backgroundImage: 'url(/images/HR2b.jpg)' }}>
	   	<div className="banner-content-wrap flex">
	   		<div className="left-block">
	   			<h3>We're thrilled to partner with the Shawn Mendes Foundation to launch Global Citizen Academy!</h3>
	   			<Link to="/academy/"
	   			className="button">EXPLORE THE ACADEMY</Link>
	   		</div>
	   		<div className="right-block">
	   			<img src="/images/GCA_X_SMF_blue.png" alt="Shawn Mendes Foundation logo" />
	   		</div>
	   	</div>
	   </div>*/
	
			);
		};
	
		return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(537);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _FooterNew = __webpack_require__(535);
	
	var _FooterNew2 = _interopRequireDefault(_FooterNew);
	
	__webpack_require__(755);
	
	__webpack_require__(754);
	
	__webpack_require__(14170);
	
	__webpack_require__(14169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Footer from "../components/Footer";
	
	
	var TemplateWrapper = function (_React$Component) {
	  _inherits(TemplateWrapper, _React$Component);
	
	  function TemplateWrapper(_ref) {
	    var props = _ref.props;
	
	    _classCallCheck(this, TemplateWrapper);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  TemplateWrapper.prototype.setCookie = function setCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	    var expires = "expires=" + d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	  };
	
	  TemplateWrapper.prototype.getUrlParams = function getUrlParams(search) {
	    var hashes = search.slice(search.indexOf("?") + 1).split("&");
	    return hashes.reduce(function (params, hash) {
	      var _extends2;
	
	      var _hash$split = hash.split("="),
	          key = _hash$split[0],
	          val = _hash$split[1];
	
	      return _extends(params, (_extends2 = {}, _extends2[key] = decodeURIComponent(val), _extends2));
	    }, {});
	  };
	
	  TemplateWrapper.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var params = this.getUrlParams(this.props.location.search);
	
	    Object.entries(params).forEach(function (param) {
	      _this2.setCookie(param[0], param[1], 30); //  2 days to expire
	    });
	  };
	
	  TemplateWrapper.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: "Global Citizen Year",
	          meta: [{ name: "description", content: "" }, { name: "keywords", content: "" }, {
	            name: "google-site-verification",
	            content: "h1s9I2U2chQB6x0ryIe-VoYMM8bTiUqfiKNx5fZ7MYA"
	          }]
	        },
	        _react2.default.createElement("link", { rel: "shortcut icon", href: "/favicon.png", type: "image/png" }),
	        _react2.default.createElement("link", {
	          rel: "canonical",
	          href: "https://www.globalcitizenyear.org" + this.props.location.pathname
	        }),
	        _react2.default.createElement(
	          "script",
	          { type: "text/javascript" },
	          "var _vwo_code=(function(){\n                   var account_id=325225,\n                   settings_tolerance=2000,\n                   library_tolerance=2500,\n                   use_existing_jquery=false,\n\n                   f=false,d=document;\n                   return{\n                       use_existing_jquery:function(){\n                           return use_existing_jquery;\n                       },library_tolerance:function(){\n                           return library_tolerance;\n                       },finish:function(){\n                           if(!f){f=true;var a=d.getElementById('_vis_opt_path_hides');if(a)a.parentNode.removeChild(a);}\n                       },finished:function(){\n                           return f;\n                       },load:function(a){\n                           var b=d.createElement('script');b.src=a;b.type='text/javascript';\n                           b.innerText;\n                           b.onerror=function(){\n                               _vwo_code.finish();\n                           };\n                           d.getElementsByTagName('head')[0].appendChild(b);\n                       },init:function(){\n                           settings_timer=setTimeout('_vwo_code.finish()',settings_tolerance)\n                           ;var a=d.createElement('style'),b='body{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}',h=d.getElementsByTagName('head')[0];a.setAttribute('id','_vis_opt_path_hides');\n                           a.setAttribute('type','text/css');\n                           if(a.styleSheet)a.styleSheet.cssText=b;\n                           else a.appendChild(d.createTextNode(b));\n                           h.appendChild(a);\n                           this.load('//dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&r='+Math.random());\n                           return settings_timer;\n                       }\n                   };\n               }());_vwo_settings_timer=_vwo_code.init()"
	        )
	      ),
	      _react2.default.createElement(_Header2.default, {
	        location: this.props.location
	      }),
	      _react2.default.createElement(
	        "div",
	        null,
	        children()
	      ),
	      _react2.default.createElement(_FooterNew2.default, null),
	      _react2.default.createElement("script", {
	        dangerouslySetInnerHTML: {
	          __html: "\n                          (function(h,o,t,j,a,r){\n                              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n                              h._hjSettings={hjid:1055036,hjsv:6};\n                              a=o.getElementsByTagName('head')[0];\n                              r=o.createElement('script');r.async=1;\n                              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n                              a.appendChild(r);\n                          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');\n                          "
	        }
	      }),
	      _react2.default.createElement("script", {
	        dangerouslySetInnerHTML: {
	          __html: "var _gaq = _gaq || [];\n                              _gaq.push(['_setAccount', 'UA-7831396-1']);\n                              _gaq.push(['_trackPageview']);\n                              (function() {\n                                var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;\n                                ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';\n                                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);\n                            })();"
	        }
	      })
	    );
	  };
	
	  return TemplateWrapper;
	}(_react2.default.Component);
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports["default"];

/***/ }),

/***/ 14169:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 14170:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-a24a7f3c82e4a6248aa1.js